/* eslint-disable camelcase */
import axios from 'axios'
export const state = {
  countries: [],
  departments: [],
  municipalities: [],
  districts: [],
  towns: [],
  profiles: [],
  actors: [],
  value_chains: [],
  domains: [],
  sae_types: [],
  events_coming: [],
  rappel_notifs: [],
  current_event_actors: [],
  event: {},
  new_event: {},
  current_event: {},
  editable_event: {},
  editable_profiles: [],
  actors_new_event: [],
  actors_editable_event: [],
  notification_msg: {},
  eventTotalItems: null
}

export const getters = {
  getCountries: state => {
    return state.countries
  },
  getDepartments: state => {
    return state.departments
  },
  getMunicipalities: state => {
    return state.municipalities
  },
  getDistricts: state => {
    return state.districts
  },
  getTowns: state => {
    return state.towns
  },
  getProfiles: state => {
    return state.profiles
  },
  getActors: state => {
    return state.actors
  },
  getEventActors: state => {
    return state.current_event_actors
  },
  getValueChains: state => {
    return state.value_chains
  },
  getDomains: state => {
    return state.domains
  },
  getSaeTypes: state => {
    return state.sae_types
  },
  getEventsComing: state => {
    return state.events_coming
  },
  getRappelNotifs: state => {
    return state.rappel_notifs
  },

  getEvent: state => {
    return state.event
  },
  getNewEvent: state => {
    return state.new_event
  },
  getActorsNewEvent: state => {
    return state.actors_new_event
  },
  getNotificationMsg: state => {
    return state.notification_msg
  },
  getCurrentEvent: state => {
    return state.current_event
  },

  getEditableEvent: state => {
    return state.editable_event
  },
  getEditableProfiles: state => {
    return state.editable_profiles
  },
  getActorsEditableEvent: state => {
    return state.actors_editable_event
  },
  eventTotalItems: state => {
    return state.eventTotalItems
  }
}

export const mutations = {
  setCountries (state, payload) {
    state.countries = payload
  },
  setDepartments (state, payload) {
    state.departments = payload
  },
  setMunicipalities (state, payload) {
    state.municipalities = payload
  },
  setDistricts (state, payload) {
    state.districts = payload
  },
  setTowns (state, payload) {
    state.towns = payload
  },
  setProfiles (state, payload) {
    state.profiles = payload
  },
  setActors (state, payload) {
    state.actors = payload
  },
  setEventActors (state, payload) {
    state.current_event_actors = payload
  },
  setValueChains (state, payload) {
    state.value_chains = payload
  },
  setDomains (state, payload) {
    state.domains = payload
  },
  setSaeTypes (state, payload) {
    state.sae_types = payload
  },
  setEventsComing (state, payload) {
    state.events_coming = payload.data
    state.eventTotalItems = payload.data.total
  },
  setRappelNotifs (state, payload) {
    state.rappel_notifs = payload
  },

  setEvent (state, payload) {
    state.event = payload
  },
  setNewEvent (state, payload) {
    state.new_event = payload
  },
  setActorsNewEvent (state, payload) {
    state.actors_new_event = payload
  },
  setNotificationMsg (state, payload) {
    state.notification_msg = payload
  },
  setCurrentEvent (state, payload) {
    state.current_event = payload
  },

  setEditableEvent (state, payload) {
    state.editable_event = payload
  },
  setEditableProfiles (state, payload) {
    state.editable_profiles = payload
  },
  setActorsEditableEvent (state, payload) {
    state.actors_editable_event = payload
  }
}

export const actions = {
  async loadCountries ({ commit }, payload) {
    const uri = '/api/countries?verify=true'
    await axios
      .get(uri)
      .then(response => {
        commit('setCountries', response.data)
      })
      .catch(err => {
        console.log('Countries error ', err)
      })
  },

  async loadDepartments ({ commit }, payload) {
    // const uri = '/api/departments?filter[country_id]=' + payload
    const uri = '/api/departments?verify=true'

    await axios
      .get(uri)
      .then(response => {
        commit('setDepartments', response.data)
      })
      .catch(err => {
        console.log('Departments error ', err)
      })
  },

  async loadMunicipalities ({ commit }, payload) {
    const uri = '/api/municipalities?verify=true&filter[department_id]=' + payload
    await axios
      .get(uri)
      .then(response => {
        commit('setMunicipalities', response.data)
      })
      .catch(err => {
        console.log('Municipalities error ', err)
      })
  },

  async loadDistricts ({ commit }, payload) {
    const uri = '/api/districts?verify=true&filter[municipality_id]=' + payload
    await axios
      .get(uri)
      .then(response => {
        commit('setDistricts', response.data)
      })
      .catch(err => {
        console.log('Districts error ', err)
      })
  },

  async loadTowns ({ commit }, payload) {
    const uri = '/api/towns?verify=true&filter[district_id]=' + payload
    await axios
      .get(uri)
      .then(response => {
        commit('setTowns', response.data)
      })
      .catch(err => {
        console.log('Towns error ', err)
      })
  },

  async loadValueChains ({ commit }, payload) {
    const uri = '/api/value_chains'
    await axios
      .get(uri)
      .then(response => {
        commit('setValueChains', response.data)
      })
      .catch(err => {
        console.log('Value Chains error ', err)
      })
  },

  async loadDomains ({ commit }, payload) {
    const uri = '/api/domains'
    await axios
      .get(uri)
      .then(response => {
        commit('setDomains', response.data)
      })
      .catch(err => {
        console.log('Domains error ', err)
      })
  },
  async loadSaeTypes ({ commit }, payload) {
    const uri = '/api/sae_types'
    await axios
      .get(uri)
      .then(response => {
        commit('setSaeTypes', response.data)
      })
      .catch(err => {
        console.log('SaeTypes error ', err)
      })
  },

  async loadProfiles ({ commit }, payload) {
    // const uri = '/api/profiles?filter[country_id]=' + payload
    const uri = '/api/profiles'
    await axios
      .get(uri)
      .then(response => {
        commit('setProfiles', response.data)
      })
      .catch(err => {
        console.log('Profiles error ', err)
      })
  },

  async loadEditableProfiles ({ commit }, payload) {
    const taille = payload.length
    const tab = []

    const uri = '/api/profiles/byuser/'
    const objet = {}
    objet.user_ids = payload

    await axios
      .post(uri, objet)
      .then(response => {
        commit('setEditableProfiles', response.data)
      })
      .catch(err => {
        console.log('Profiles edition error ', err)
      })
  },

  async loadActors ({ commit }, payload) {
    const uri = `/api/actorsValueChain`
    await axios
      .post(uri, payload)
      .then(response => {
        commit('setActors', response.data)
      })
      .catch(err => {
        console.log('Actors error ', err)
      })
  },

  async loadEventActors ({ commit }, payload) {
    const uri = `/api/events/${payload.event_id}/participants?page=${payload ? payload.page : 1
      }`
    await axios
      .get(uri)
      .then(response => {
        commit('setEventActors', response.data)
      })
      .catch(err => {
        console.log('Event actors error ', err)
      })
  },

  async loadEventsComing ({ commit }, payload, search) {
    console.log({ search })
    const uri =
      payload +
      '&include=municipality,domain,saeType,users,country,department,district,town,chains,user_level_one,user_level_two'
    await axios
      .get(uri)
      .then(response => {
        commit('setEventsComing', response)
        commit('setNewEvent', null)
        commit('setEvent', null)
        commit('setEditableEvent', null)
        commit('setActorsNewEvent', null)
        commit('setNotificationMsg', null)
        commit('setEditableProfiles', null)
      })
      .catch(err => {
        console.log('Events coming error ', err)
      })
  },
  async validateEvents (context, payload) {
    try {
      await axios.post(`/api/events-validate`, { 'ids': payload.ids })
      // context.dispatch('loadEventsComing', payload.uri)
    } catch (e) { }
  },

  // L'import tourne en file d'attente côté serveur : le compte rendu arrive par e-mail
  importEventActors ({ dispatch }, payload) {
    const formData = new FormData()
    formData.append('file', payload.file)

    dispatch('responseMessage', {
      type: 'info',
      text: 'Envoi du fichier en cours...'
    })

    return axios
      .post('/api/events/' + payload.eventId + '/actors/import', formData)
      .then(response => {
        dispatch('responseMessage', {
          type: 'success',
          text: response.data.message
        })
      })
      .catch(err => {
        const errors = err.response && err.response.data.errors
        let text = "Une erreur s'est produite lors de l'import du fichier."
        if (errors && errors.message) {
          text = errors.message
        } else if (errors && errors.file) {
          text = errors.file[0]
        }
        dispatch('responseMessage', { type: 'error', text })
      })
  },

  loadCurrentEvent ({ commit }, payload) {
    /* const uri = '/api/events/' + payload + '?filter[id]=' + payload +
'?&include=country,users,municipality,domain,actors,department,district,town,chains';*/

    const uri = '/api/events/' + payload + '?filter[id]=' + payload

    axios
      .get(uri)
      .then(response => {
        commit('setCurrentEvent', response.data)
      })
      .catch(err => {
        console.log('Current event error ', err)
      })
  },

  async loadEditableEvent ({ commit }, payload) {
    const evenement_id = payload.event_id
    const route_edit = payload.router

    if (
      this.getters.getCurrentEvent != null &&
      evenement_id == this.getters.getCurrentEvent.id
    ) {
      commit('setEditableEvent', this.getters.getCurrentEvent)
      route_edit.push({
        name: 'events.edit',
        params: { Pid: evenement_id }
      })
    } else {
      const uri =
        '/api/events/' +
        evenement_id +
        '?filter[id]=' +
        evenement_id +
        '?&include=country,users,municipality,domain,actors,department,district,town,chains'
      await axios
        .get(uri)
        .then(response => {
          commit('setEditableEvent', response.data)
        })
        .catch(err => {
          console.log('Editable event error ', err)
        })

      setTimeout(
        route_edit.push({
          name: 'events.edit',
          params: { Pid: evenement_id }
        }),
        1000
      )
    }
  },

  loadRappelNotifs ({ commit }, payload) {
    const uri = '/api/notification_messages?filter[event_id]=' + payload

    axios
      .get(uri)
      .then(response => {
        commit('setRappelNotifs', response.data)
      })
      .catch(err => {
        console.log('Notification rappels error ', err)
      })
  },

  storeEvent1 ({ commit }, payload) {
    commit('setNewEvent', payload)
  },

  storeEvent2 ({ commit }, payload) {
    const evenement = JSON.parse(JSON.stringify(this.getters.getNewEvent))
    console.log({ evenement, payload })
    evenement.user_ids = payload.user_ids
    evenement.staff_name = payload.staff_name
    evenement.sae_type_id = payload.sae_type_id
    evenement.event_type_id = payload.event_type_id
    evenement.organisator_type_id = payload.organisator_type_id
    commit('setNewEvent', evenement)
  },

  storeEvent3 ({ commit }, payload) {
    const evenement = this.getters.getNewEvent
    const liste = []
    const liste_actors = []
    payload.forEach(function (element) {
      liste.push(element.id)
      liste_actors.push({
        id: element.id,
        contact: element.contact,
        language: element.language
      })
    })
    evenement.actor_ids = liste
    evenement.actors_count = liste.length

    commit('setNewEvent', evenement)
    commit('setActorsNewEvent', liste_actors)
  },

  async createEvent ({ commit }) {
    const evenement = this.getters.getNewEvent
    evenement.message_key = 'none'
    try {
      const { data } = await axios.post('/api/events', evenement)
      commit('setEvent', data)
      commit('setNewEvent', null)
      return true
    } catch (e) {
      console.log(e)
      return false
    }
  },

  async storeEvent ({ commit }, payload) {
    const evenement = this.getters.getNewEvent
    evenement.event_type_id = payload.event_type_id
    evenement.message_key = 'none'

    /* console.log("Date envoi ", payload.sending_date)
console.log("Heure envoi ", payload.sending_hour) */

    let id_evenement = null
    const uri = '/api/events'
    const uri_notif = '/api/notification_messages'
    const taille = payload.language.length
    const router = payload.router
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    }
    await axios
      .post(uri, evenement)
      .then(response => {
        commit('setNewEvent', response.data)

        // Saving notification when event is saved successfully-------
        id_evenement = this.getters.getNewEvent.id

        if (id_evenement == null) {
          id_evenement = response.data.id
        }

        for (let k = 0; k < taille; k++) {
          const notif = new FormData()
          let langue = payload.language[k]
          const liste = payload.actor_contacts[langue]
          let contacts = ''

          liste.forEach(function (item) {
            contacts = item.contact + ',' + contacts
          })

          if (langue == null || langue == undefined) {
            langue = 'Français'
          }

          notif.append('language', langue)
          notif.append('audio_msg', payload.audio_msg[k])
          notif.append('sms', payload.sms[k])
          notif.append('actor_contacts', contacts)
          notif.append('sending_date', payload.sending_date)
          notif.append('sending_hour', payload.sending_hour)
          notif.append('event_id', id_evenement)
          notif.append('audio_path', payload.audio_path[k])

          axios
            .post(uri_notif, notif, config)
            .then(response => {
              commit('setNotificationMsg', response.data)
            })
            .catch(err => {
              console.log(
                'Notification message event_id ',
                id_evenement
              )
              console.log('Notification message error ', err)
            })
        } // End for
      })
      .catch(err => {
        console.log('New event error ', err)
      })

    setTimeout(
      router.push({
        name: 'events.coming',
        params: { new_event_added: true }
      }),
      2000
    )

    /* let notif_users = evenement.user_ids;
  const uri_notif_mail = '/api/send-notif';
  axios.post(uri_notif_mail, notif_users)
    .then(response =>{ console.log("Ok mail notif envoyé ", response.data)} )
    .catch(err =>{ console.log("Erreur d'envoi du mail de notif ", err)} );*/
  },

  updateEvent1 ({ commit }, payload) {
    commit('setEditableEvent', payload)
  },

  updateEvent2 ({ commit }, payload) {
    const evenement = JSON.parse(
      JSON.stringify(this.getters.getEditableEvent)
    )
    evenement.user_ids = payload.user_ids
    evenement.staff_name = payload.staff_name
    evenement.sae_type_id = payload.sae_type_id
    evenement.organisator_type_id = payload.organisator_type_id
    evenement.event_type_id = payload.event_type_id
    commit('setEditableEvent', evenement)
  },

  updateEvent3 ({ commit }, payload) {
    const evenement = JSON.parse(JSON.stringify(this.getters.getEditableEvent))
    const liste = []
    const liste_actors = []
    payload.forEach(function (element) {
      liste.push(element.id)
      liste_actors.push({
        id: element.id,
        contact: element.contact,
        language: element.language
      })
    })
    evenement.actor_ids = liste
    evenement.actors_count = liste.length

    commit('setEditableEvent', evenement)
    commit('setActorsEditableEvent', liste_actors)
  },

  async updateEvent ({ commit }) {
    const evenement = this.getters.getEditableEvent
    evenement.message_key = 'none'
    try {
      const { data } = await axios.put(
        '/api/events/' + evenement.id,
        evenement
      )
      commit('setEditableEvent', data)
      return true
    } catch (e) {
      console.log(e)
      return false
    }
  },

  updateEvent4 ({ commit }, payload) {
    const evenement = this.getters.getEditableEvent
    evenement.message_key = 'none'

    const id_evenement = evenement.id
    const uri = '/api/events/' + id_evenement
    const uri_notif = '/api/notification_messages/'
    const taille = payload.language.length
    const router = payload.router
    const config = {
      headers: { 'content-type': 'multipart/form-data' }
    }

    axios
      .put(uri, evenement)
      .then(response => {
        commit('setEditableEvent', response.data)
      })
      .catch(err => {
        console.log('Update event error ', err)
      })

    for (let k = 0; k < taille; k++) {
      const notif = new FormData()
      const notif_2 = new FormData()
      let langue = payload.language[k]
      const liste = payload.actor_contacts[langue]
      let contacts = ''

      liste.forEach(function (item) {
        contacts = item.contact + ',' + contacts
      })

      if (langue == null || langue == undefined) {
        langue = 'Français'
      }

      // uri_notif = uri_notif+payload.id[k];
      // console.log("Update notif object ", payload);

      if (
        payload.is_audio_upd[k] === true ||
        payload.is_audio_upd[k] === 'true'
      ) {
        notif.append('id', payload.id[k])
        notif.append('language', langue)
        notif.append('audio_msg', payload.audio_msg[k])
        notif.append('sms', payload.sms[k])
        notif.append('actor_contacts', contacts)
        notif.append('event_id', id_evenement)
        notif.append('sending_date', payload.sending_date)
        notif.append('sending_hour', payload.sending_hour)
        notif.append('audio_path', payload.audio_path[k])

        const uri_del = uri_notif + payload.id[k]

        axios
          .delete(uri_del)
          .then(response => {
            axios
              .post(uri_notif, notif, config)
              .then(response => {
                commit('setNotificationMsg', response.data)
              })
              .catch(err => {
                console.log(
                  'Update Notification message error ',
                  err
                )
              })
          })
          .catch(err => {
            console.log(
              'Notification message deletion error ',
              err
            )
          })
      } // End Audio is updated
      else {
        console.log(payload)
        notif_2.append('id', payload.id[k])
        notif_2.append('language', langue)
        notif_2.append('audio_msg', payload.audio_msg[k])
        notif_2.append('sms', payload.sms[k])
        notif_2.append('actor_contacts', contacts)
        notif_2.append('event_id', id_evenement)
        notif_2.append('sending_date', payload.sending_date)
        notif_2.append('sending_hour', payload.sending_hour)
        notif_2.append('audio_path', payload.audio_path[k])

        // let uri_upd = uri_notif+payload.id[k];
        const uri_del = uri_notif + payload.id[k]

        // axios.delete(uri_del)
        //   .then(response => {

        //   })
        //   .catch( err => { console.log("Notification message deletion error ", err) });

        axios
          .post(uri_notif, notif_2)
          .then(response => {
            commit('setNotificationMsg', response.data)
          })
          .catch(err => {
            console.log('Update Notification message error ', err)
          })
      }
    } // End for

    setTimeout(
      router.push({
        name: 'events.coming',
        params: { event_updated: true }
      }),
      2000
    )
  },

  searchEvent ({ commit }, payload) {
    const uri =
      '/api/events-search?page=' +
      payload.page +
      '&event_type=' +
      payload.type

    axios
      .post(uri, payload)
      .then(response => {
        commit('setEventsComing', response.data)
      })
      .catch(err => {
        console.log('Search error ', err)
      })
  },

  loadLocaleFr ({ commit }, payload) {
    payload.locale('fr', {
      months: 'Janvier_Février_Mars_Avril_Mai_Juin_Juillet_Août_Septembre_Octobre_Novembre_Décembre'.split(
        '_'
      ),
      monthsShort: 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
        '_'
      ),
      monthsParseExact: true,
      weekdays: 'Dimanche_Lundi_Mardi_Mercredi_Jeudi_Vendredi_Samedi'.split(
        '_'
      ),
      weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
      weekdaysMin: 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
      weekdaysParseExact: true,
      longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd D MMMM YYYY HH:mm'
      },
      calendar: {
        sameDay: '[Aujourd’hui à] LT',
        nextDay: '[Demain à] LT',
        nextWeek: 'dddd [à] LT',
        lastDay: '[Hier à] LT',
        lastWeek: 'dddd [dernier à] LT',
        sameElse: 'L'
      },
      relativeTime: {
        future: 'dans %s',
        past: 'il y a %s',
        s: 'quelques secondes',
        m: 'une minute',
        mm: '%d minutes',
        h: 'une heure',
        hh: '%d heures',
        d: 'un jour',
        dd: '%d jours',
        M: 'un mois',
        MM: '%d mois',
        y: 'un an',
        yy: '%d ans'
      },
      dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
      ordinal: function (number) {
        return number + (number === 1 ? 'er' : 'e')
      },
      meridiemParse: /PD|MD/,
      isPM: function (input) {
        return input.charAt(0) === 'M'
      },
      // In case the meridiem units are not separated around 12, then implement
      // this function (look at locale/id.js for an example).
      // meridiemHour : function (hour, meridiem) {
      //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
      // },
      meridiem: function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD'
      },
      week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4 // Used to determine first week of the year.
      }
    })
    payload.locale('fr')
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/event.js